module.exports = __webpack_public_path__ + "img/icon_study-time.772cc1d8.png";